export default __webpack_public_path__ + "static/media/nft-transparent.c120351e.png";